/**
 * ReferralsTab — shared referral program tab.
 * Used in StudentDashboard and TutorDashboard.
 *
 * Props:
 *   referralStats - { referral_code, total_referrals, completed_referrals, total_coins_earned }
 */
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../ui/card';
import { Button } from '../ui/button';

const ReferralsTab = ({ referralStats }) => (
    <Card>
        <CardHeader>
            <CardTitle>Referral Program</CardTitle>
            <CardDescription>
                Invite friends and earn 50 coins for each successful referral!
            </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
            {referralStats && (
                <>
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
                        <p className="text-sm text-gray-600 mb-2">Your Referral Code</p>
                        <div className="flex items-center space-x-3">
                            <code className="text-2xl font-bold text-blue-600 bg-white px-4 py-2 rounded border">
                                {referralStats.referral_code}
                            </code>
                            <Button
                                size="sm"
                                onClick={() => {
                                    navigator.clipboard.writeText(referralStats.referral_code);
                                    alert('Copied to clipboard!');
                                }}
                            >
                                Copy Code
                            </Button>
                        </div>
                    </div>

                    <div className="grid md:grid-cols-3 gap-4">
                        <div className="text-center p-4 bg-gray-50 rounded-lg">
                            <p className="text-2xl font-bold text-gray-900">{referralStats.total_referrals}</p>
                            <p className="text-sm text-gray-600">Total Referrals</p>
                        </div>
                        <div className="text-center p-4 bg-gray-50 rounded-lg">
                            <p className="text-2xl font-bold text-gray-900">{referralStats.completed_referrals}</p>
                            <p className="text-sm text-gray-600">Completed</p>
                        </div>
                        <div className="text-center p-4 bg-green-50 rounded-lg">
                            <p className="text-2xl font-bold text-green-600">{referralStats.total_coins_earned}</p>
                            <p className="text-sm text-gray-600">Coins Earned</p>
                        </div>
                    </div>
                </>
            )}
        </CardContent>
    </Card>
);

export default ReferralsTab;
